import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'

import classnames from 'classnames'

import { Position, Toaster } from '@blueprintjs/core'
import { selectPlayerAction } from '../actions/playerActions'

const PlayerTokenToaster = Toaster.create({
    className: 'playerTokenToaster',
    position: Position.BOTTOM_RIGHT
})

class PlayerToken extends Component {
    constructor(props) {
        super(props)
    } 

    handleClick(player) {
        PlayerTokenToaster.show({
            message: "Time for " + this.props.playerJSON.characterName + " to get a move on!" 
        })
        this.props.dispatch(
            selectPlayerAction(player)
        )
    }

    render() {
        let playerColor = classnames({
            'playerToken': true,
            'playerWhite': this.props.playerJSON.characterName === "Mrs. White",
            'playerBlue': this.props.playerJSON.characterName === "Mrs. Peacock",
            'playerGreen': this.props.playerJSON.characterName === "Mr. Green",
            'playerOrange': this.props.playerJSON.characterName === "Colonel Mustard",
            'playerRed': this.props.playerJSON.characterName === "Miss Scarlett",
            'playerPurple': this.props.playerJSON.characterName === "Professor Plum"
        })
        return(
            <div className={playerColor} onClick={() => this.handleClick(this.props.player)}>
                {this.props.playerJSON.characterName}
            </div>
        )
    }
}

export default connect()(PlayerToken)



// WEBPACK FOOTER //
// ./src/components/PlayerToken.jsx